export const suggestions = [
  'What can you help me with?',
  'Explain quantum computing',
  'Write a Python script',
  'What time is it?',
]

export const projectSuggestions = [
  'Generate architecture diagram',
  'Explain this codebase',
  'Find potential issues',
  'What can you help me with?',
]
